<template>
  <div>
    <b-row class="pl-2 pr-2">
      <b-col class="col-md-12 col-12">
        <div>
          <h1 class="font-weight-500 text-center mb-0 mt-3">
            Stats
          </h1>
          <hr />
        </div>
        <div class="mt-md-0 mb-5 tt-mt">
          <b-alert v-if="exportError" show variant="danger">
            Unable to export stas data, there is no data for selected tax season
          </b-alert>

          <div v-if="isLoading" class="overlay">
            <div class="gooey">
              <div class="text">Loading Stats</div>
              <span class="dot"></span>
              <div class="dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>

          <b-list-group>
            <div class="d-flex justify-content-between mb-3">
              <button
                class="align-content-start mt-3 btn-light btn tt-border-radius"
                @click="selectedYear--"
              >
                <b-icon icon="chevron-left" aria-hidden="true"></b-icon>
                Previous Year
              </button>
              <button
                class="align-content-start mt-3 btn-light btn tt-border-radius"
                @click="selectedYear++"
              >
                Next Year
                <b-icon icon="chevron-right" aria-hidden="true"></b-icon>
              </button>
            </div>
            <b-form-group
              label="Cars"
              id="input-3"
              class="col-md-12 text-left p-0 mt-4"
              v-if="carList.length > 1"
            >
              <select class="custom-select" name="" v-model.lazy="selectedCar">
                <option
                  v-for="car in carList"
                  :value="car"
                  :key="car._id"
                  :selected="car.is_default_car === true"
                  >{{ car.make }}</option
                >
              </select>
            </b-form-group>
          </b-list-group>
          <b-list-group class="tt-border-radius">
            <b-list-group-item
              class="d-flex justify-content-left bg-primary align-items-center text-white tt-bg tt-border-radius"
            >
              Travel logs - <b>Tax Year {{ startDate.getFullYear() + 1 }}</b>
            </b-list-group-item>
            <b-list-group-item class="text-left tt-border-radius">
              <div class="row">
                <div class="col-4">
                  <p>Starting Date</p>
                </div>
                <div class="text-center col-8">
                  <p>{{ startDate.toDateString() }}</p>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item class="text-left">
              <div class="row">
                <div class="col-4">
                  <p>Total Kilometer</p>
                </div>
                <div class="text-center col-8">
                  <p>{{ totalKilometer }}</p>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item class="text-left">
              <div class="row">
                <div class="col-4">
                  <p>Total Business Kilometer</p>
                </div>
                <div class="text-center col-8">
                  <p>{{ businessKilometer }}</p>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item class="text-left">
              <div class="row">
                <div class="col-4">
                  <p>Total Expense Cost</p>
                </div>
                <div class="text-center col-8">
                  <p>{{ totalCostExpenses }}</p>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item class="text-left tt-border-radius">
              <div class="row">
                <div class="col-4">
                  <p>Total Litres bought</p>
                </div>
                <div class="text-center col-8">
                  <p>{{ totalLitres }} Litre(s)</p>
                </div>
              </div>
            </b-list-group-item>
            <div class="row mt-4" v-if="isloggedIn">
              <div class="col-md-9">
                Each Tax year travel starts are exported separately, View
                required required tax year above and click "Export"
              </div>
              <div class="col-md-3">
                <button
                  :disabled="!isloggedIn"
                  class="tt-button btn text-white btn-success tt-border-radius mt-md-0 mt-3"
                  @click="exportData(startDate, closingDate)"
                >
                  <b-icon icon="download"></b-icon>
                  Export Tax Year
                </button>
              </div>
            </div>
          </b-list-group>
        </div>
      </b-col>
      <b-modal
        id="modal-center"
        centered
        title="Delete"
        header-bg-variant="tt-bg"
      >
        <template>
          <p>Are you sure about this action ?</p>
        </template>

        <template #modal-footer="{ ok, cancel }">
          <b-button
            class="tt-button"
            @click="
              deleteTrip();
              ok();
            "
          >
            Delete
          </b-button>
          <b-button variant="danger" @click="cancel()">
            Cancel
          </b-button>
        </template>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import axios from "axios";
import moment from "moment";
import download from "downloadjs";

export default {
  name: "Stats",
  data() {
    return {
      selectedCar: "",
      selectedYear: new Date().getFullYear(),
      exportError: false
    };
  },
  props: {},

  created() {
    // this.$store.commit("stat/getStartDate", this.selectedYear);
    var vm = this;
    setTimeout(() => {
      console.log(vm.defaultVehicle);
      vm.selectedCar = vm.defaultVehicle;
      vm.$store.dispatch("stat/getStatAction", [vm.defaultVehicle._id, true]);
      vm.selectedYear = vm.startDate.getFullYear();
    }, 1000);
  },
  computed: {
    ...mapState({
      currentSeasonTrips: state => state.stat.currentSeasonTrips,
      totalKilometer: state => state.stat.totalKilometer,
      openingDate: state => state.stat.startDate,
      closingDate: state => state.stat.closingDate,
      isLoading: state => state.isLoading,
      isloggedIn: state => state.auth.isAuth
    }),
    ...mapGetters({
      startDate: "stat/getStartDate",
      totalKilometer: "stat/getTotalKilometer",
      businessKilometer: "stat/getBusinessKilometer",
      // expenses: "stat/getExpenses",
      totalCostExpenses: "stat/getTotalExpenseCost",
      totalLitres: "stat/getTotalFuelLitres",
      carsArr: "stat/carsArr",
      getDefaultCarsList: "car/getDefaultCarsList",
      getUsersSavedCarsList: "car/getUsersSavedCarsList",
      defaultVehicle: "car/getDefaultCar"
    }),
    carList: function() {
      return [this.defaultVehicle, ...this.getUsersSavedCarsList];
    }
  },
  watch: {
    selectedCar: function(car) {
      if (car) {
        this.$store.dispatch("stat/getStatAction", [
          car._id,
          car.is_default_car
        ]);
      }
    },
    selectedYear: function() {
      // console.log(this.selectedCar);
      this.$store.commit("stat/getStartDate", this.selectedYear);
      this.$store.dispatch("stat/getStatAction", [
        this.selectedCar._id,
        this.selectedCar.is_default_car
      ]);
    }
  },
  methods: {
    exportData: function(startSeason, endSeason) {
      const taxSeasonStart = moment(startSeason).format("Y-MM-DD");
      const taxSeasonEnd = moment(endSeason).format("Y-MM-DD");
      const vm = this;

      axios
        .post(
          "/logbook/export_trips_and_expenses",
          {
            seasonStart: taxSeasonStart,
            seasonEnd: taxSeasonEnd,
            carPouchId: vm.selectedCar._id,
            isDefaultCar: vm.selectedCar.is_default_car
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("jwt")
            },
            responseType: "blob"
          }
        )
        .then(function(response) {
          if (response.data.type === "application/pdf") {
            vm.exportError = false;
            download(response.data, "logbook_export.pdf", "application/pdf");
          } else {
            vm.exportError = true;
          }
        }) // eslint-disable-next-line no-unused-vars
        .catch(function(error) {});
    }
  }
};
</script>

<style lang="scss">
.text {
  margin-left: 10px;
  width: 100%;
  height: 20px;
}
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1000;
  left: 0px;
  background-color: rgba(255, 255, 255, 0.9);
}
.gooey {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 142px;
  height: 20px;
  margin: -20px 0 0 -71px;
  background-color: transparent;
  filter: contrast(20);
  z-index: 1200;
}
.dot {
  position: absolute;
  width: 16px;
  height: 16px;
  top: 32px;
  left: 15px;
  filter: blur(0px);
  background: #000;
  border-radius: 50%;
  transform: translateX(0);
  animation: dot 2.8s infinite;
}
.dots {
  transform: translateX(0);
  margin-top: 12px;
  margin-left: 31px;
  animation: dots 2.8s infinite;
}
.dots span {
  display: block;
  float: left;
  width: 16px;
  height: 16px;
  margin-left: 16px;
  filter: blur(0px);
  background: #000;
  border-radius: 50%;
}
@-moz-keyframes dot {
  50% {
    transform: translateX(96px);
  }
}
@-webkit-keyframes dot {
  50% {
    transform: translateX(96px);
  }
}
@-o-keyframes dot {
  50% {
    transform: translateX(96px);
  }
}
@keyframes dot {
  50% {
    transform: translateX(96px);
  }
}
@-moz-keyframes dots {
  50% {
    transform: translateX(-31px);
  }
}
@-webkit-keyframes dots {
  50% {
    transform: translateX(-31px);
  }
}
@-o-keyframes dots {
  50% {
    transform: translateX(-31px);
  }
}
@keyframes dots {
  50% {
    transform: translateX(-31px);
  }
}
</style>
